/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import NotFoundPage from 'pages/NotFoundPage';
import TeamPage from 'pages/TeamPage';
import Blog from 'pages/Blog';
import CrmPage from 'pages/CrmPage';
import ERP from 'pages/resourceplanning';
import Marketing from 'pages/Marketing';
import Sales from 'pages/sales';
import Projects from 'pages/Projects';
import People from 'pages/people';
import Invoices from 'pages/Invoices';
import Services from 'pages/Services';

import { ProjectDetailPage } from 'pages/ProjectDetailPage';
import { BlogDetailPage } from 'pages/BlogDetailPage';
import { DiscussProjectPage } from 'pages/DiscussProjectPage';

import './assets/css/styles.css';

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route exact path="/team" element={<TeamPage />} />
        <Route exact path="/services" element={<Services />} />
        <Route exact path="/discuss-project" element={<DiscussProjectPage />} />
        <Route path="**" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
